define('Extended.ReorderItems.Collection'
    , ['Extended.ReorderItems.Model'
        , 'underscore'
        , 'Transaction.Line.Collection'
        , 'Utils'
    ]
    , function (
        ExtendedReorderItemsModel
        , _
        , TransactionLineCollection
        , Utils
    ) {
        'use strict';

        return TransactionLineCollection.extend({

            url: Utils.getAbsoluteUrl('services/ReorderItems.Service.ss')

            , model: ExtendedReorderItemsModel

            , parse: function (response) {
                this.totalRecordsFound = response.totalRecordsFound;
                this.recordsPerPage = response.recordsPerPage;

                return response.records;
            }

            , update: function (options, list_header) {
                var data_filters = {
                    sort: options.sort.value
                    , order_id: this.order_id
                    , order: options.order
                    , page: options.page
                };

                if (!this.order_id) {
                    var date_string = options.filter.value.apply(list_header.view);
                    date_string = date_string && date_string.split('T');

                    data_filters.from = date_string[0];
                    data_filters.to = date_string[1];
                }

                this.fetch({
                    data: data_filters
                    , reset: true
                    , killerId: options.killerId
                });
            }
        });
    });
